export default "__VITE_ASSET__BPUnICJg__"